// extracted by mini-css-extract-plugin
export default {"richText":"RichText__richText___DB5Ld","config":"RichText__config___s3IcV","toolbar":"RichText__toolbar___j08lu"};